var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.5 42.5",
    style: {
      enableBackground: "new 0 0 42.5 42.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3,0C9.5,0,0,9.5,0,21.3C0,33,9.5,42.5,21.3,42.5S42.5,33,42.5,21.3C42.5,9.5,33,0,21.3,0z M31.4,27.2 c0.5,0.5,0.5,1.3,0,1.8L29,31.4c-0.5,0.5-1.3,0.5-1.8,0l-5.9-5.9l-5.9,5.9c-0.5,0.5-1.3,0.5-1.8,0L11.2,29c-0.5-0.5-0.5-1.3,0-1.8 l5.9-5.9l-5.9-5.9c-0.5-0.5-0.5-1.3,0-1.8l2.3-2.3c0.5-0.5,1.3-0.5,1.8,0l5.9,5.9l5.9-5.9c0.5-0.5,1.3-0.5,1.8,0l2.3,2.3 c0.5,0.5,0.5,1.3,0,1.8l-5.9,5.9L31.4,27.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5d819a5801d0b961137e2bece75e7a76.svg";
export { ForwardRef as ReactComponent };